import { useState, useEffect } from 'react'
import { authService } from '@/services/api'
import type { User, LoginCredentials } from '@/types'

export function useAuth() {
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    checkAuthStatus()
  }, [])

  const checkAuthStatus = () => {
    try {
      const token = authService.getToken()
      const savedUser = authService.getUser()
      
      if (token && savedUser) {
        setUser(savedUser)
        setIsAuthenticated(true)
      } else {
        setUser(null)
        setIsAuthenticated(false)
      }
    } catch (error) {
      console.error('Erro ao verificar status de autenticação:', error)
      authService.removeToken()
      setUser(null)
      setIsAuthenticated(false)
    } finally {
      setIsLoading(false)
    }
  }

  const login = async (login: string, senha: string) => {
    setIsLoading(true)
    
    try {
      const credentials: LoginCredentials = { login, senha }
      const response = await authService.login(credentials)
      
      if (response.sucess && response.user) {
        // Armazenar token se existir
        if (response.user.token) {
          authService.setToken(response.user.token)
        }
        
        // Armazenar dados do usuário
        authService.setUser(response.user)
        setUser(response.user)
        setIsAuthenticated(true)
      } else {
        console.error('Login falhou:', response.message)
        throw new Error(response.message || 'Erro na autenticação')
      }
    } catch (error) {
      console.error('Erro no processo de login:', error)
      authService.removeToken()
      setUser(null)
      setIsAuthenticated(false)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  const logout = () => {
    authService.removeToken()
    setUser(null)
    setIsAuthenticated(false)
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
  }
}
